import $ from 'jquery';

$( '.toggle-post-type' ).on( 'click', function ( e ) {
	e.preventDefault();
	$( '.toggle-post-type' ).removeClass( 'target-group__button-buttons--active' );
	$( '#events-tab, #projects-tab, #news-tab, #team-tab' ).addClass( 'hide' );
	var target = $( this ).data( 'target' );
	$( '#' + target ).removeClass( 'hide' );
	$( this ).addClass( 'target-group__button-buttons--active' );
	Foundation.reInit( 'equalizer' );
} );

function initializeLoadMore( selector, loadMoreId ) {
	var $container      = $( selector );
	var $anchorElements = $container.find( 'a' );
	var visibleCount    = 8;

	function updateVisibility() {
		$anchorElements.each( function ( index ) {
			if ( index < visibleCount ) {
				$( this ).css( 'display', 'block' );
			} else {
				$( this ).css( 'display', 'none' );
			}
		} );

		if ( visibleCount > 8 ) {
			var $lastDisplayed = $anchorElements.eq( visibleCount - 8 );
			$( 'html, body' ).animate( {
				scrollTop: $lastDisplayed.offset().top
			}, 1000 );
		}
	}

	updateVisibility();

	var $loadMoreButton = $( loadMoreId );

	// Check at the beginning if there are more than 8 items
	if ( $anchorElements.length > 8 ) {
		$loadMoreButton.css( 'display', 'block' );
	} else {
		$loadMoreButton.css( 'display', 'none' );
	}

	$loadMoreButton.on( 'click', () => {
		visibleCount += 8;
		updateVisibility();

		if ( visibleCount >= $anchorElements.length ) {
			$loadMoreButton.hide();
		}
	} );
}

initializeLoadMore( '.news-events-projects__wrapper--team', '#team-load-more' );
initializeLoadMore( '.news-events-projects__wrapper--projects', '#projects-load-more' );